import React, { useState } from 'react';
import { Phone, MapPin, Mail, XIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy text-white pt-24 pb-12 border-t border-white/10" data-id="element-156">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20" data-id="element-158">
            {/* Brand */}
            <div className="space-y-8" data-id="element-159">
              <div className="flex items-center gap-4" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/mHQYWDhNJXGSPsTWooPTGm/Photoroom_20260425_171611.png" alt="Blue Sky Logo" className="h-16 w-auto object-contain opacity-90" data-id="element-161" />
                <div data-id="element-162">
                  <span className="block font-heading font-bold text-2xl leading-none tracking-widest" data-id="element-163">
                    BLUE SKY
                  </span>
                  <span className="block text-[10px] uppercase tracking-[0.2em] text-gold mt-1.5" data-id="element-164">
                    General Contractor LLC
                  </span>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed font-light italic" data-id="element-165">
                "From first call to final finish — we make the whole process
                easy & exciting"
              </p>
              <div className="flex gap-4" data-id="element-166">
                <span className="inline-block px-3 py-1 bg-white/5 border border-white/10 rounded-sm text-xs text-gray-400 tracking-wider" data-id="element-167">
                  PA #934782
                </span>
                <span className="inline-block px-3 py-1 bg-white/5 border border-white/10 rounded-sm text-xs text-gray-400 tracking-wider" data-id="element-168">
                  OSHA #14-602163933
                </span>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-169">
              <h4 className="font-heading font-bold text-lg mb-8 text-white tracking-wider" data-id="element-170">
                Quick Links
              </h4>
              <ul className="space-y-4" data-id="element-171">
                {['About Us', 'Our Services', 'Service Areas', 'Testimonials', 'Free Estimate'].map((link, i) => <li key={i} data-id="element-172">
                    <a href={`#${link.toLowerCase().split(' ')[0]}`} className="text-gray-400 hover:text-gold transition-colors text-sm tracking-wide" data-id="element-173">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-174">
              <h4 className="font-heading font-bold text-lg mb-8 text-white tracking-wider" data-id="element-175">
                Contact Us
              </h4>
              <ul className="space-y-5" data-id="element-176">
                <li data-id="element-177">
                  <a href="tel:2158245130" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors text-sm tracking-wide" data-id="element-178">
                    <Phone className="w-4 h-4 text-gold" data-id="element-179" />
                    (215) 824-5130
                  </a>
                </li>
                <li data-id="element-180">
                  <a href="mailto:blueskycontractorllc23@gmail.com" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors text-sm tracking-wide" data-id="element-181">
                    <Mail className="w-4 h-4 text-gold" data-id="element-182" />
                    blueskycontractorllc23@gmail.com
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-183">
            <p className="text-gray-500 text-xs tracking-wider uppercase" data-id="element-184">
              © {new Date().getFullYear()} Blue Sky General Contractor LLC. All
              rights reserved.
            </p>
            <div className="flex items-center gap-6" data-id="element-185">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 hover:text-gold text-xs tracking-wider uppercase transition-colors" data-id="element-186">
                Privacy Policy
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gray-500 hover:text-gold text-xs tracking-wider uppercase transition-colors" data-id="element-187">
                Terms of Service
              </button>
            </div>
            <p className="text-gray-500 text-xs tracking-wider uppercase flex items-center gap-2" data-id="element-188">
              Serving Pennsylvania with Pride{' '}
              <span className="text-gold" data-id="element-189">✦</span>
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-190">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-191">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-lg" data-id="element-192">
              <h2 className="font-heading font-bold text-xl text-navy tracking-wide" data-id="element-193">
                Privacy Policy
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="text-gray-400 hover:text-navy transition-colors" data-id="element-194">
                <XIcon className="w-5 h-5" data-id="element-195" />
              </button>
            </div>
            <div className="px-6 py-6 text-sm text-gray-600 leading-relaxed space-y-4" data-id="element-196">
              <p className="text-xs text-gray-400 uppercase tracking-wider" data-id="element-197">
                Last updated:{' '}
                {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
              </p>
              <p data-id="element-198">
                Blue Sky General Contractor LLC ("we," "us," or "our") is
                committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, and safeguard your personal
                information when you visit our website or use our services.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-199">
                Information We Collect
              </h3>
              <p data-id="element-200">
                We may collect personal information that you voluntarily
                provide, including your name, phone number, email address,
                property address, and project details when you request a free
                estimate or contact us.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-201">
                How We Use Your Information
              </h3>
              <p data-id="element-202">
                We use your information to respond to inquiries, provide
                estimates, schedule and perform services, communicate about your
                project, and improve our services. We do not sell or rent your
                personal information to third parties.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-203">
                Data Security
              </h3>
              <p data-id="element-204">
                We implement reasonable security measures to protect your
                personal information. However, no method of transmission over
                the internet is 100% secure, and we cannot guarantee absolute
                security.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-205">Cookies</h3>
              <p data-id="element-206">
                Our website may use cookies to enhance your browsing experience.
                You can set your browser to refuse cookies, though some features
                may not function properly.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-207">Contact Us</h3>
              <p data-id="element-208">
                If you have questions about this Privacy Policy, please contact
                us at your convenience through our website or by phone.
              </p>
            </div>
          </div>
        </div>}

      {/* Terms of Service Modal */}
      {showTerms && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-209">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-210">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-lg" data-id="element-211">
              <h2 className="font-heading font-bold text-xl text-navy tracking-wide" data-id="element-212">
                Terms of Service
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-navy transition-colors" data-id="element-213">
                <XIcon className="w-5 h-5" data-id="element-214" />
              </button>
            </div>
            <div className="px-6 py-6 text-sm text-gray-600 leading-relaxed space-y-4" data-id="element-215">
              <p className="text-xs text-gray-400 uppercase tracking-wider" data-id="element-216">
                Last updated:{' '}
                {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
              </p>
              <p data-id="element-217">
                Welcome to Blue Sky General Contractor LLC. By accessing our
                website or engaging our services, you agree to the following
                terms and conditions.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-218">Services</h3>
              <p data-id="element-219">
                We provide general contracting services including but not
                limited to roofing, siding, windows, gutters, and related home
                improvement work in the state of Pennsylvania. All work is
                performed in accordance with applicable local and state
                regulations.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-220">
                Estimates & Pricing
              </h3>
              <p data-id="element-221">
                Free estimates are provided based on initial assessments. Final
                pricing may vary depending on actual project conditions,
                material costs, and scope changes. A written contract will be
                provided before any work begins.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-222">Warranties</h3>
              <p data-id="element-223">
                We stand behind our workmanship. Specific warranty terms will be
                outlined in your project contract. Manufacturer warranties on
                materials are separate and subject to the manufacturer's terms.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-224">
                Limitation of Liability
              </h3>
              <p data-id="element-225">
                Blue Sky General Contractor LLC shall not be liable for delays
                or failures caused by circumstances beyond our reasonable
                control, including weather, supply chain disruptions, or permit
                delays.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-226">
                Governing Law
              </h3>
              <p data-id="element-227">
                These terms are governed by the laws of the Commonwealth of
                Pennsylvania. Any disputes shall be resolved in the appropriate
                courts of Pennsylvania.
              </p>
              <h3 className="font-bold text-navy text-base mt-6" data-id="element-228">Contact</h3>
              <p data-id="element-229">
                For questions regarding these terms, please reach out to us
                through our website or by phone.
              </p>
            </div>
          </div>
        </div>}
    </>;
}